import {
  MOON_500,
  MOON_600,
  MOON_800,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: 60px 20px 20px 20px;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';

export const DrawerLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
DrawerLayout.displayName = 'S.DrawerLayout';

export const TopPanel = styled.div`
  flex: 1 1 auto;
`;
TopPanel.displayName = 'S.TopPanel';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
`;
HeaderRow.displayName = 'S.HeaderRow';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
`;
Header.displayName = 'S.Header';

export const Close = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
Close.displayName = 'S.Close';

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;
Description.displayName = 'S.Description';

export const FormLabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;
FormLabelRow.displayName = 'S.FormLabelRow';

export const FormCheckboxRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
`;
FormCheckboxRow.displayName = 'S.FormCheckboxRow';

export const FormLabel = styled.div`
  color: ${MOON_800};
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  margin-top: 16px;
  flex 1 1 auto;
`;
FormLabel.displayName = 'S.FormLabel';

export const InlineFormLabel = styled.div`
  color: ${MOON_800};
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  flex 1 1 auto;
`;
InlineFormLabel.displayName = 'S.InlineFormLabel';

export const HintText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${MOON_500};
  margin-top: 0px;
`;
HintText.displayName = 'S.HintText';

export const FormLabelHelp = styled.div`
  flex: 1 1 auto;
  color: ${MOON_600};
  font-size: 16px;
  line-height: 32px;
  margin-top: 16px;
  text-align: right;
`;
FormLabelHelp.displayName = 'S.FormLabelHelp';

export const FormLabelButtons = styled.div`
  margin-top: 16px;
`;
FormLabelButtons.displayName = 'S.FormLabelButtons';

export const HelpRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`;
HelpRow.displayName = 'S.HelpRow';

export const HelpMessage = styled.div`
  color: ${MOON_600};
`;
HelpMessage.displayName = 'S.HelpMessage';

export const Spacer = styled.div`
  height: 16px;
`;
